import React, { useEffect, useState } from "react";
import Card from "src/components/Cards/Basic";
import axios from "src/config/axios";
import { useParams } from "react-router-dom";
import { Formik, Form } from "formik";
import { Button, Spinner } from "react-bootstrap";
import MultiLanguageInputText from "src/components/Forms/MultiLanguageInputText";
import { showErrorToast, showSuccessToast } from "src/components/Toasts";
import FormInputText from "src/components/Forms/FormInputText";
import FormCheckbox from "src/components/Forms/FormCheckbox";

const LANGUAGES = ["de", "it", "en"];

const AdminBookingSettingReservationPage = () => {
  const { id } = useParams();
  const [reservationSettings, setReservationSettings] = useState(null);

  useEffect(() => {
    loadReservationSettings();
  }, [id]);

  const loadReservationSettings = () => {
    axios
      .get(`/api/v1/admin/businesses/${id}/online_reservation_settings.json`)
      .then(({ data }) => {
        setReservationSettings(data);
      })
      .catch(() => showErrorToast());
  };

  const submit = (values) => {
    axios
      .put(`/api/v1/admin/businesses/${id}/online_reservation_settings.json`, {
        online_reservation_setting: values,
      })
      .then(() => {
        showSuccessToast();
        loadReservationSettings();
      })
      .catch(() => showErrorToast());
  };

  return (
    <Card title="Online Reservation Settings">
      <Formik
        initialValues={reservationSettings || {}}
        onSubmit={submit}
        enableReinitialize
      >
        {({ values, isSubmitting }) => (
          <Form>
            {!reservationSettings ? (
              <Spinner
                className={"d-block mx-auto"}
                animation="border"
                variant="primary"
              />
            ) : (
              <>
                <MultiLanguageInputText
                  label="Success Redirect URL"
                  name="success_redirect_url"
                  languages={LANGUAGES}
                />

                <FormCheckbox
                  className={"flex-grow-1"}
                  label={"QR-Code aktivieren"}
                  name={"qr_code_enabled"}
                  hint={
                    "Fügt der Reservierungsbestätigung einen QR-Code für den Scanner an der Eingangssäule hinzu."
                  }
                />

                <h3>Zahlungsmethoden</h3>

                <FormCheckbox
                  className={"flex-grow-1"}
                  label={"Stripe aktivieren"}
                  name={"stripe_enabled"}
                />

                {values.stripe_enabled && (
                  <>
                    <FormInputText
                      name={"stripe_only_if_arrival_within_days"}
                      label={
                        "Stripe nur für kurzfristige Reservierungen anzeigen"
                      }
                      hint={
                        "Innerhalb wie vielen Tagen vor Anreise soll Stripe angezeigt werden."
                      }
                    />
                    <FormInputText
                      type={"number"}
                      name={"stripe_commission_percent"}
                      label={"Stripe Kommission in Prozent"}
                    />

                    <FormInputText
                      type={"number"}
                      name={"stripe_commission_min_cents"}
                      label={"Minimale Stripe Kommission in Cent"}
                    />
                  </>
                )}

                <FormCheckbox
                  className={"flex-grow-1"}
                  label={"Manuelle Banküberweisung aktivieren"}
                  name={"bank_transfer_enabled"}
                />

                {values.bank_transfer_enabled && (
                  <FormInputText
                    name={"bank_transfer_hide_if_arrival_within_days"}
                    label={
                      "Innerhalb wie vielen Tagen soll die Banküberweisung für kurzfristige Reservierungen ausgeblendet werden."
                    }
                  />
                )}

                <Button type="submit">Speichern</Button>
              </>
            )}
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default AdminBookingSettingReservationPage;
